import { AuthErrorType, useAuth } from "./useAuth";
import { TrackEvent, track } from "~/utils/analytics";
import {
  getAuthRedirectErrorResult,
  loginWithGoogle,
  loginWithMicrosoft,
} from "~/network/user-api";
import { useCallback, useEffect, useState } from "react";

export enum Mode {
  signinMagicLink,
  confirmMagicLinkSent,
  signinEnterPassword,
  confirmForgotPasswordSent,
  setPassword,
}

export type LoginContainerVM = {
  tappedGoogleLoginButton: () => void;
  tappedMicrosoftLoginButton: () => void;
  loading: boolean;
  errorMessage?: string;
};

function useLoginContainer(): LoginContainerVM {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const auth = useAuth();

  useEffect(() => {
    getAuthRedirectErrorResult()
      .then((message) => {
        if (message) {
          setErrorMessage(message);
        }
      })
      .catch(console.error);
  }, []);
  const tappedGoogleLoginButton = useCallback(async () => {
    track(TrackEvent.loginWithGmail);
    setLoading(true);
    try {
      await loginWithGoogle();
    } catch (err) {
      console.error("useLoginContainer/loginWithGoogle/Error", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const tappedMicrosoftLoginButton = useCallback(async () => {
    track(TrackEvent.loginWithMicrosoft);
    setLoading(true);
    try {
      await loginWithMicrosoft();
    } catch (err) {
      console.error("useLoginContainer/loginWithMicrosoft/Error", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (auth.errorType === AuthErrorType.UNVERIFIED) {
      setErrorMessage(auth.error?.message);
    }
  }, [auth.errorType, auth.error]);

  return {
    loading,
    tappedGoogleLoginButton,
    tappedMicrosoftLoginButton,
    errorMessage,
  };
}

export default useLoginContainer;
